export default {
  title: 'Produkty',
  buttons: {
    add_product: 'Dodaj produkt',
  },
  modals: {
    delete_product: {
      title: 'Czy jesteś pewny',
      description:
        'Wszystkie aktywne subskrypcje tego produktu pozostaną aktywne, ale nie będzie można tworzyć nowych. Tej operacji nie można cofnąć!',
    },
    delete_price: {
      title: 'Czy jesteś pewny',
      description:
        'Wszystkie aktywne subskrypcje z tą ceną pozostaną aktywne, ale nie będzie można tworzyć nowych. Tej operacji nie można cofnąć!',
    },
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych',
    failed_to_delete_product: 'Nie udało się usunąć produktu',
    product_got_deleted: 'Produkt został usunięty',
    failed_to_delete_price: 'Nie udało się usunąć ceny',
    price_got_deleted: 'Cena została usunięta',
  },
};
